<p-toast position="top-right" key="pdf-error"></p-toast>
<p-breadcrumb styleClass="p-mt-4" [home]="home" [model]="model"></p-breadcrumb>
<div class="p-pt-3">
    <div class="p-grid p-y-3 p-mb-3">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-start">

                <div>
                    <button pButton pRipple class="p-button-secondary" (click)="goBack()"
                            icon="pi pi-arrow-left"></button>
                </div>

<!--                <div class="p-ml-3">-->
                <!--                    <button style="cursor:not-allowed;" pButton pRipple class="p-button-secondary"-->
                <!--                            (click)="allowToExport === 'true' ? printPdf() : null" label="Print"-->
                <!--                    ><img src="assets/branding/shared-icons/print-white.svg" alt=""-->
                <!--                          style="height: calc(0.9rem + .55vmin)">&nbsp;&nbsp;-->
                <!--                    </button>-->
                <!--                </div>-->
                <div class="p-ml-3">
                    <button pButton pRipple class="p-button-secondary" [style]="allowToExport === 'true' ? '' : 'cursor: not-allowed'"
                            (click)="allowToExport === 'true' ? downloadPdf() : null" label="Download"
                    ><img src="assets/branding/shared-icons/download-white.svg" alt=""
                          style="height: calc(0.9rem + .55vmin)"
                          >&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>


    <div class="card p-d-flex p-jc-center p-ai-center width-100" style="min-height: 75vh; max-height: 75vh">
        <div class="p-text-center" *ngIf="isLoading">
            <div>
                <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 2rem;"></i>
            </div>
            <div class="p-mt-3 p-text-secondary">
                {{'Loading Document !'}}
            </div>
        </div>

        <!--            <ngx-extended-pdf-viewer showDownloadButton="true" [src]="pdfSrc" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>-->
        <div *ngIf="pdfSrc">
            <pdf-viewer id="printFrame"
                        [fit-to-page]="true"
                        [src]="pdfSrc"
                        [render-text]="true"
                        useBrowserLocale="true"
                        [autoresize]="true"
            >
            </pdf-viewer>
            <!--            <ngx-extended-pdf-viewer [src]="pdfSrc" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>-->

        </div>
    </div>
</div>
